import { appConfig } from "@/app/module_api";
import { buildBasicAuthorizationHeader } from "@/utils/auth";

export type CallTokenResult = {
  token: string;
  jitsiUrl?: string;
};

export async function fetchCallToken(
  roomId: string,
  bearerToken: string
): Promise<CallTokenResult> {
  const response = await fetch(`${appConfig.apiUrl.replace(/\/$/, "")}/get-call-token`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: buildBasicAuthorizationHeader(bearerToken),
    },
    body: JSON.stringify({ room: roomId }),
  });

  if (!response.ok) {
    throw new Error(`get-call-token failed (${response.status})`);
  }

  const data = (await response.json()) as {
    token?: string;
    jitsiUrl?: string;
    jitsi_url?: string;
  };
  const token = (data.token || "").trim();
  if (!token) {
    throw new Error("get-call-token response missing token");
  }

  const jitsiUrl = (data.jitsiUrl || data.jitsi_url || "").trim() || undefined;
  return { token, jitsiUrl };
}
